/**
 * LotoWheel Modal — Tab Sorteos Virtuales
 * Se extiende sobre LotowheelModule declarado en lotowheel.js
 */

import { LotowheelModule } from './lotowheel.js';
import { App, Api } from '../../../admin.js';
import { icon } from '../../../utils/icon.js';
import { t } from '../../../services/i18n-admin.js';

Object.assign(LotowheelModule, {
    // ====================================================================
    // SORTEOS VIRTUALES — KPIs + tabla + acciones
    // ====================================================================

    async loadVirtualDraws() {
        const [stats, drawsData] = await Promise.all([Api.getVirtualDrawsStats(), Api.getVirtualDraws()]);

        if (stats) {
            const vdActiveCount = document.getElementById('vdActiveCount');
            if (vdActiveCount) vdActiveCount.textContent = stats.virtualDraws || 0;
            const memoryKB = (stats.drawProvider?.virtualDrawsCount || 0) * 2;
            const vdMemory = document.getElementById('vdMemory');
            if (vdMemory)
                vdMemory.textContent = memoryKB > 1024 ? (memoryKB / 1024).toFixed(1) + ' MB' : memoryKB + ' KB';
            const vdTotalCreated = document.getElementById('vdTotalCreated');
            if (vdTotalCreated) vdTotalCreated.textContent = stats.totalActive || 0;
        }

        const tbody = document.getElementById('virtualDrawsTable');
        if (!tbody) return;

        if (!drawsData || !drawsData.draws || drawsData.draws.length === 0) {
            tbody.innerHTML =
                '<tr><td colspan="6" style="text-align:center; padding:24px; color:var(--text-secondary);">' + t('No hay sorteos virtuales activos') + '</td></tr>';
            return;
        }

        let html = '';
        for (let i = 0; i < drawsData.draws.length; i++) {
            const d = drawsData.draws[i];
            html +=
                '<tr>' +
                '<td data-label="ID"><code>' +
                d.id +
                '</code></td>' +
                '<td data-label="' + t('Propietario') + '">' +
                d.ownerType +
                ': ' +
                d.ownerId +
                '</td>' +
                '<td data-label="' + t('Sorteo #') + '">' +
                d.numSorteo +
                '</td>' +
                '<td data-label="' + t('Intervalo') + '">' +
                d.intervaloSegundos +
                's</td>' +
                '<td data-label="Estado"><span class="badge ' +
                (d.activo ? 'badge-green' : 'badge-red') +
                '">' +
                (d.activo ? 'Activo' : 'Inactivo') +
                '</span></td>' +
                '<td data-label="Acciones">' +
                '<button class="btn-icon" data-action="lotowheel:triggerVirtualDraw" data-id="' +
                d.id +
                '" title="' + t('Ejecutar sorteo') + '">' +
                icon('play') +
                '</button>' +
                '<button class="btn-icon btn-danger" data-action="lotowheel:stopVirtualDraw" data-id="' +
                d.id +
                '" title="' + t('Detener') + '">' +
                icon('square') +
                '</button>' +
                '</td>' +
                '</tr>';
        }
        tbody.innerHTML = html;
    },

    async recoverVirtualDraws() {
        const result = await Api.recoverVirtualDraws();
        if (result && result.ok) {
            App.toast((result.recovered?.length || 0) + t(' sorteos recuperados'));
            this.loadVirtualDraws();
        }
    },

    async createVirtualDrawPrompt() {
        const drawId = prompt(t('ID del sorteo virtual (ej: vdraw:user:test):'));
        if (!drawId) return;

        const templateId = prompt(t('ID del LotoWheel base (template):'), '1');
        if (!templateId) return;

        const result = await Api.createVirtualDraw({
            drawId,
            templateLotowheelConfigId: parseInt(templateId, 10),
            ownerId: drawId.split(':').slice(1).join(':') || drawId,
            ownerType: 'manual',
        });

        if (result && result.ok) {
            App.toast(t('Sorteo virtual creado: ') + drawId);
            this.loadVirtualDraws();
        }
    },

    async triggerVirtualDraw(drawId) {
        const result = await Api.triggerVirtualDraw(drawId);
        if (result && result.ok) {
            App.toast(t('Sorteo ejecutado: ') + (result.resultado?.numero ?? '?'));
            this.loadVirtualDraws();
        }
    },

    async stopVirtualDraw(drawId) {
        if (!confirm(t('¿Detener sorteo virtual ') + drawId + '?')) return;
        const result = await Api.stopVirtualDraw(drawId);
        if (result && result.ok) {
            App.toast(t('Sorteo detenido: ') + drawId);
            this.loadVirtualDraws();
        }
    },
});
